var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudForm',{attrs:{"title":_vm.title,"labelSubmit":_vm.labelSubmit,"storeName":_vm.storeName,"parentStoreName":"Options","submit":_vm.submit,"status":_vm.status,"breadcrumbs":[
    {
      text: 'Reservas y estadías',
      disabled: false,
      href: '/admin/options'
    },
    {
      text: '...',
      disabled: false,
      href: '#'
    },
    {
      text: _vm.$route.params.id ? 'Editar' : 'Crear',
      disabled: true,
      href: '#'
    }
  ]}},[_c('ValidationObserver',{ref:"validator",scopedSlots:_vm._u([{key:"default",fn:function({}){return [_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('ValidationProvider',{ref:"option",attrs:{"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('div',{staticClass:"label-base pb-1"},[_vm._v("Opción")]),_c('v-text-field',{staticClass:"input-base",attrs:{"error-messages":errors,"label":"Ingrese aquí la opción","solo":"","hide-details":"auto"},model:{value:(_vm.data.option),callback:function ($$v) {_vm.$set(_vm.data, "option", $$v)},expression:"data.option"}})]}}],null,true)})],1)],1)],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }